export const LANDOUR_PROD_CTI = 'SantosLandour';
export const LANDOUR_GAMMA_CTI = 'SantosLandourGamma';

// If the script is loaded from this domain, use the prod CTI
const PROD_HOSTNAME = 'landour.tuxedo.prod.barossa.dubai.aws.dev';

export const getCTIFromScriptUrl = (importUrl: string) => {
    try {
        const scriptUrl = new URL(importUrl);
        return PROD_HOSTNAME.includes(scriptUrl.hostname)
            ? LANDOUR_PROD_CTI
            : LANDOUR_GAMMA_CTI;
    } catch (error) {
        return LANDOUR_PROD_CTI;
    }
};
